// @flow

import React, { type Node, useState } from 'react';
import styled from 'styled-components';
import { IfFeature } from '@tectonics/prs/feature';
import { useIncomingPayment, getMerchant } from '@tectonics/prs/incoming-payment';
import { getName as getMerchantName, getMerchantLogo } from '@tectonics/prs/merchant';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

import { MerchantLogoDisplay } from './merchant-logo-display';
import { ToggleButton } from './toggle-button';
import { InfoBox } from './info-box';
import { Separator } from '../../atoms';

const PaymentInfoWrapper = styled.div`
  border: 1px solid #eee;
  border-radius: 3px;
  color: ${props => props.theme.colors.black};
`;

export const MobileLayout = styled.div`
  padding: 16px;
  @media (min-width: 840px) {
    display: none;
   }
`;

export function MobileDisplayValues(): Node {
  const incomingPayment = useIncomingPayment();
  const merchant = getMerchant(incomingPayment);
  const allFeatures = useAllFeatures();
  const [toggleValue, setToggleValue] = useState(true);

  return (
    <MobileLayout>
      <MerchantLogoDisplay logoSrc={getMerchantLogo(merchant)} fallbackText={getMerchantName(merchant)} />
      <Separator direction="vertical" size={3} />
      <PaymentInfoWrapper onClick={() => setToggleValue(!toggleValue)} >
        <IfFeature allFeatures={allFeatures} wanted="display_receipt_final_amount">
          <ToggleButton />
        </IfFeature>

        {toggleValue && (
          <InfoBox />
        )}
      </PaymentInfoWrapper>
    </MobileLayout>
  );
}
